import React, { useState } from 'react';
import './CheckInOut.css';

export const DealButton = () => {
  const [activeButton, setActiveButton] = useState('Ongoing');

  return (
    <div className="button-container">
      <button
        onClick={() => setActiveButton('Ongoing')}
        className={`button ${activeButton === 'Ongoing' ? 'active' : ''}`}
      >
        Ongoing
      </button>
      <button
        onClick={() => setActiveButton('Finished')}
        className={`button ${activeButton === 'Finished' ? 'active' : ''}`}
      >
        Finished
      </button>
    </div>
  );
};

export default DealButton;
